module.exports = __webpack_public_path__ + "static/Footer banner A - Green Copy-9bc7ccf6c7e7020999f2e4c726276671.png";